var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('img',{attrs:{"src":require("@/assets/icons/tooltip.svg"),"alt":"Tooltip"},on:{"mouseover":_vm.openTip,"mouseleave":_vm.closeTip}}),(_vm.tooltip)?_c('div',{staticClass:"tip"},[(_vm.tip)?_c('p',[_vm._v(_vm._s(_vm.tip))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }